import React, { ReactNode, useRef } from 'react';
import { strToBase64 } from './base64';
import { classNames } from '../style';
import { useObfuscation } from '.';

export interface LinkObfuscatedProps {
  href: string;
  blank?: boolean;
  className?: string;
  onMouseEnter?: any;
  onMouseLeave?: any;
  onClick?: any;
  children: ReactNode;
  navigate?: (url: string) => void;
}
export const LinkObfuscated = ({
  href,
  blank = false,
  className,
  children,
  navigate,
  ...props
}: LinkObfuscatedProps) => {
  const ref = useRef<HTMLElement>(null);

  useObfuscation(ref, href, navigate);

  return (
    <span
      data-target={blank}
      {...props}
      ref={ref}
      data-qcd={strToBase64(href)}
      className={classNames('cursor-pointer', className)}
      role="link"
      tabIndex={0}
    >
      {children}
    </span>
  );
};
